
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[type]",
      function () {
        return require("private-next-pages/auth/[type].js");
      }
    ]);
  